"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetInfoRequest = void 0;
var GetInfoRequest = /** @class */ (function () {
    function GetInfoRequest() {
    }
    return GetInfoRequest;
}());
exports.GetInfoRequest = GetInfoRequest;
;
//# sourceMappingURL=getInfo.request.js.map